function getName(url) {
  const parts = url.split('__');

  if (parts.length > 1) {
    return parts.slice(0, -1).join('');
  }

  return url.split('.').slice(0, -1).join('.');
}

function getExtension(url) {
  return url.split('.').pop();
}

export default function getImageStyle(url, style) {
  const name = getName(url);
  const extension = getExtension(url);

  if (style) {
    return `${name}__${style}.${extension}`;
  }

  return `${name}.${extension}`;
}
